<template>
  <div class="navbar">
    <router-link to="/" class="logo">
      <img src="@/assets/images/icons/logo.svg" alt="logo" />
    </router-link>
    <span @click="login" class="login" :class="{ 'login-btn': !getUser }">
      {{ loginText }}
    </span>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
export default {
  computed: {
    ...mapGetters("User", ["getUser"]),
    loginText () {
      if (this.getUser) {
        return this.getUser.email
      } else { return "LOG IN" }
    },
  },
  methods: {
    ...mapMutations("Store", ["setLoginModalShow"]),
    login () {
      if (this.getUser) {
        return
      }
      this.setLoginModalShow(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 5.5rem;
  background: #18181b;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3.3rem;
  position: fixed;
  z-index: 10;
  top: 0;
  .logo {
    img {
      width: 3rem;
    }
  }
  .login {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 1.9rem;
    letter-spacing: 0.08em;
    color: #ffffff;
    &.login-btn {
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/SimpleNavbar.vue